import Vue from 'vue';
const DEFAULT_NETWORKS = [
    { key: 'whatsapp', label: 'WhatsApp', icon: 'whatsapp' },
    { key: 'telegram', label: 'Telegram', icon: 'telegram' },
    { key: 'facebook', label: 'Facebook', icon: 'facebook' },
    { key: 'x', label: 'X', icon: 'x' },
    { key: 'linkedin', label: 'LinkedIn', icon: 'linkedin' },
    { key: 'email', label: 'Email', icon: 'email' },
];
/**
 * Self-contained icons. No dependency on your existing <svg-icon>.
 * (They’re simple, recognizable marks — not a full brand pack.)
 */
const ShareIcon = Vue.extend({
    name: 'ShareIcon',
    functional: true,
    props: { name: { type: String, required: true } },
    render(h, ctx) {
        const name = String(ctx.props.name || '');
        const cls = ctx.data.class;
        const svg = (children, viewBox = '0 0 24 24') => h('svg', {
            class: cls,
            attrs: {
                viewBox,
                width: '18px',
                height: '18px',
                focusable: 'false',
                'aria-hidden': 'true',
            },
        }, children);
        // Minimal, clean icons using currentColor so they inherit theme colors.
        switch (name) {
            case 'share':
                return svg([
                    h('circle', { attrs: { cx: 18, cy: 5.5, r: 2 } }),
                    h('circle', { attrs: { cx: 6, cy: 12, r: 2 } }),
                    h('circle', { attrs: { cx: 18, cy: 18.5, r: 2 } }),
                    h('path', {
                        attrs: {
                            d: 'M7.7 11.1l8-4.2M7.7 12.9l8 4.2',
                            fill: 'none',
                            stroke: 'currentColor',
                            'stroke-width': 2,
                            'stroke-linecap': 'round',
                        },
                    }),
                ]);
            case 'close':
                return svg([
                    h('path', {
                        attrs: {
                            d: 'M6 6l12 12M18 6L6 18',
                            fill: 'none',
                            stroke: '#212121',
                            'stroke-width': 2,
                            'stroke-linecap': 'round',
                        },
                    }),
                ]);
            case 'link':
                return svg([
                    h('path', {
                        attrs: {
                            d: 'M10 13a4 4 0 0 1 0-6l1.2-1.2a4 4 0 0 1 5.6 5.6L16 12',
                            fill: 'none',
                            stroke: 'currentColor',
                            'stroke-width': 2,
                            'stroke-linecap': 'round',
                            'stroke-linejoin': 'round',
                        },
                    }),
                    h('path', {
                        attrs: {
                            d: 'M14 11a4 4 0 0 1 0 6L12.8 18.2a4 4 0 1 1-5.6-5.6L8 12',
                            fill: 'none',
                            stroke: 'currentColor',
                            'stroke-width': 2,
                            'stroke-linecap': 'round',
                            'stroke-linejoin': 'round',
                        },
                    }),
                ]);
            case 'more':
                return svg([
                    h('circle', { attrs: { cx: 5, cy: 12, r: 1.6 } }),
                    h('circle', { attrs: { cx: 12, cy: 12, r: 1.6 } }),
                    h('circle', { attrs: { cx: 19, cy: 12, r: 1.6 } }),
                ]);
            // Simple brand-ish glyphs (recognizable enough for UI). Use currentColor.
            case 'facebook':
                return svg([
                    h('path', {
                        attrs: {
                            d: 'M14 8.5h2V6h-2c-2.2 0-3.5 1.4-3.5 3.7V12H8.5v2.5h2V21H13v-6.5h2.7L16 12h-3V9.9c0-1 .3-1.4 1-1.4z',
                            fill: 'currentColor',
                        },
                    }),
                ]);
            case 'whatsapp':
                return svg([
                    h('path', {
                        attrs: {
                            d: 'M12 3a9 9 0 0 0-7.7 13.6L3 21l4.5-1.2A9 9 0 1 0 12 3z',
                            fill: 'none',
                            stroke: 'currentColor',
                            'stroke-width': 2,
                            'stroke-linejoin': 'round',
                        },
                    }),
                    h('path', {
                        attrs: {
                            d: 'M9.2 8.6c.2-.5.4-.6.8-.6h.6c.2 0 .4.1.5.3l.9 1.9c.1.2.1.4 0 .6l-.5.6c-.1.1-.1.3 0 .5.6 1 1.6 1.9 2.7 2.4.2.1.4.1.5-.1l.6-.6c.2-.1.4-.2.6-.1l2 .9c.2.1.3.3.3.5v.7c0 .4-.2.7-.6.8-.7.3-2 .6-3.7-.1-2.1-.9-4.5-3.5-5.2-5.7-.4-1.4-.1-2.6.2-3.3z',
                            fill: 'currentColor',
                        },
                    }),
                ]);
            case 'telegram':
                return svg([
                    h('path', {
                        attrs: {
                            d: 'M21 5L3.8 11.8c-.9.3-.9 1.6 0 1.9l4.1 1.4 1.6 4.6c.3.9 1.6 1 2 .2l2.4-4.2 4.3 3.2c.7.5 1.7.1 1.9-.8L22 6.4c.2-1-1-1.7-1.9-1.4zM8.6 14.8l9.5-6.1-7.4 7.3-.3 3.1-1.4-4.3-3.1-1z',
                            fill: 'currentColor',
                        },
                    }),
                ]);
            case 'x':
                return svg([
                    h('path', {
                        attrs: {
                            d: 'M18.6 4H20l-6.6 7.6L20.5 20H15l-4.3-5.2L6.2 20H4.8l7.1-8.2L3.5 4H9l3.9 4.7L18.6 4z',
                            fill: 'currentColor',
                        },
                    }),
                ]);
            case 'linkedin':
                return svg([
                    h('path', { attrs: { d: 'M5.5 9H8v11H5.5V9zM6.75 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z', fill: 'currentColor' } }),
                    h('path', { attrs: { d: 'M10 9h2.4v1.5h.1c.4-.8 1.5-1.7 3.1-1.7 3 0 3.6 2 3.6 4.7V20H16.7v-5.2c0-1.3 0-3-1.8-3s-2.1 1.4-2.1 2.9V20H10V9z', fill: 'currentColor' } }),
                ]);
            case 'email':
                return svg([
                    h('path', {
                        attrs: {
                            d: 'M4 6h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z',
                            fill: 'none',
                            stroke: 'currentColor',
                            'stroke-width': 2,
                            'stroke-linejoin': 'round',
                        },
                    }),
                    h('path', {
                        attrs: {
                            d: 'M22 8l-10 6L2 8',
                            fill: 'none',
                            stroke: 'currentColor',
                            'stroke-width': 2,
                            'stroke-linecap': 'round',
                            'stroke-linejoin': 'round',
                        },
                    }),
                ]);
            default:
                // fallback: empty box
                return svg([h('rect', { attrs: { x: 4, y: 4, width: 16, height: 16, fill: 'none', stroke: 'currentColor', 'stroke-width': 2 } })]);
        }
    },
});
export default Vue.extend({
    name: 'ProductShare',
    components: { ShareIcon },
    props: {
        title: { type: String, default: '' },
        description: { type: String, default: '' },
        url: { type: String, default: '' },
        networks: { type: Array, default: () => DEFAULT_NETWORKS },
        closeOnShareClick: { type: Boolean, default: true },
        preferNativeShare: { type: Boolean, default: false },
    },
    data() {
        return {
            open: false,
            copied: false,
            copiedTimer: null,
            prevOverflow: '',
        };
    },
    computed: {
        isClient() {
            return typeof window !== 'undefined';
        },
        shareUrl() {
            if (this.url)
                return this.url;
            return this.isClient ? window.location.href : '';
        },
        shareTitle() {
            return this.title || (this.isClient ? document.title : '');
        },
        shareText() {
            const t = this.shareTitle;
            const d = this.description ? ` — ${this.description}` : '';
            return `${t}${d}`.trim();
        },
        resolvedNetworks() {
            return (this.networks && this.networks.length) ? this.networks : DEFAULT_NETWORKS;
        },
        canNativeShare() {
            return this.isClient && typeof navigator.share === 'function';
        },
    },
    watch: {
        open(v) {
            if (!this.isClient)
                return;
            // lock body scroll when modal open
            if (v) {
                this.prevOverflow = document.documentElement.style.overflow || '';
                document.documentElement.style.overflow = 'hidden';
                document.addEventListener('keydown', this.onKeydown, true);
                this.$nextTick(() => {
                    const panel = this.$el.querySelector('.cts-share__panel');
                    panel?.focus?.();
                });
            }
            else {
                document.documentElement.style.overflow = this.prevOverflow;
                document.removeEventListener('keydown', this.onKeydown, true);
                this.$nextTick(() => this.$refs.trigger?.focus?.());
            }
        },
    },
    beforeDestroy() {
        if (!this.isClient)
            return;
        document.removeEventListener('keydown', this.onKeydown, true);
        document.documentElement.style.overflow = this.prevOverflow;
        if (this.copiedTimer)
            window.clearTimeout(this.copiedTimer);
    },
    methods: {
        onKeydown(e) {
            if (e.key === 'Escape')
                this.close();
        },
        async onTriggerClick() {
            if (this.preferNativeShare && this.canNativeShare) {
                const ok = await this.tryNativeShare();
                if (ok)
                    return;
            }
            this.open = true;
        },
        close() {
            this.open = false;
        },
        onNetworkClick(network) {
            this.$emit('share-open', { network, url: this.shareUrl });
            if (this.closeOnShareClick)
                this.close();
        },
        encode(v) {
            return encodeURIComponent(v || '');
        },
        buildShareHref(network) {
            const u = this.encode(this.shareUrl);
            const text = this.encode(this.shareText);
            const title = this.encode(this.shareTitle);
            switch (network) {
                case 'facebook':
                    return `https://www.facebook.com/sharer/sharer.php?u=${u}`;
                case 'whatsapp':
                    return `https://wa.me/?text=${text}%20${u}`;
                case 'telegram':
                    return `https://t.me/share/url?url=${u}&text=${text}`;
                case 'x':
                    return `https://twitter.com/intent/tweet?text=${text}&url=${u}`;
                case 'linkedin':
                    return `https://www.linkedin.com/sharing/share-offsite/?url=${u}`;
                case 'email':
                    return `mailto:?subject=${title}&body=${text}%0A${u}`;
                default:
                    return this.shareUrl;
            }
        },
        async nativeShare() {
            await this.tryNativeShare();
        },
        async tryNativeShare() {
            try {
                const nav = navigator;
                await nav.share({
                    title: this.shareTitle,
                    text: this.description || this.shareTitle,
                    url: this.shareUrl,
                });
                this.$emit('native-share', { url: this.shareUrl });
                this.close();
                return true;
            }
            catch {
                return false;
            }
        },
        async copyLink() {
            const url = this.shareUrl;
            if (!url || !this.isClient)
                return;
            try {
                if (navigator.clipboard?.writeText) {
                    await navigator.clipboard.writeText(url);
                }
                else {
                    const input = document.createElement('input');
                    input.value = url;
                    input.setAttribute('readonly', 'true');
                    input.style.position = 'fixed';
                    input.style.left = '-9999px';
                    document.body.appendChild(input);
                    input.select();
                    document.execCommand('copy');
                    document.body.removeChild(input);
                }
                this.copied = true;
                this.$emit('copied', { url });
                if (this.copiedTimer)
                    window.clearTimeout(this.copiedTimer);
                this.copiedTimer = window.setTimeout(() => (this.copied = false), 1200);
            }
            catch {
                this.$emit('copy-failed', { url });
            }
        },
    },
});
